export enum DocumentWindowMessageType {
    openPreviewModal = 'openPreviewModal',
}
